import React, { useCallback } from 'react';
import { Dropdown, DropdownButton, DropdownPopper, Flex } from '@zillow/constellation';
import styled from 'styled-components';
import { DropdownHeader } from './dropdown/DropdownHeader';
import { DropdownFooter } from './dropdown/DropdownFooter';
import { DropdownBody } from './dropdown/DropdownBody';
import { KeyboardShortcutsList } from './KeyboardShortcutsList';
import { CustomViewsContextProvider, useCustomViewsContext } from './context/CustomViewsContext';

export const CustomViewsContainer: React.FC = () => {
  return (
    <CustomViewsContextProvider>
      <Flex display={'flex'} flexDirection={'row'} gap={'sm'}>
        <KeyboardShortcutsList />
        <CustomViewsDropdown />
      </Flex>
    </CustomViewsContextProvider>
  );
};

const CustomViewsDropdown: React.FC = () => {
  const { customViewsState, setCustomViewsState, resetContext } = useCustomViewsContext();

  const onOpen = useCallback(() => {
    setCustomViewsState((prevState) => ({ ...prevState, isOpen: true }));
  }, [setCustomViewsState]);

  return (
    <DropdownPopper
      triggered={
        <RounderDropdown
          renderHeader={<DropdownHeader />}
          renderBody={<OverflowDropdownBody />}
          renderFooter={<DropdownFooter />}
        />
      }
      isOpen={customViewsState.isOpen}
      onOpen={onOpen}
      onClose={resetContext}
    >
      <DropdownButton>Custom view</DropdownButton>
    </DropdownPopper>
  );
};

const RounderDropdown = styled(Dropdown)`
  width: 480px;
  max-height: 620px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

const OverflowDropdownBody = styled(DropdownBody)`
  overflow: auto;
  flex-grow: 1;
`;
